
<template>
  <b-modal
    ref="modal"
    hide-footer
    title="QR-Code Scan"
    header-class="bg-primary text-white"
  >
    <div class="text-center">
      <vue-qrcode
        v-if="token"
        :title="titel"
        :value="token"
        :options="{ width: 466, scale: 8, margin: 0 }"
        @hidden="onHide"
      ></vue-qrcode>
    </div>

    <div class="mt-3 text-center">
      <router-link
        v-if="token"
        class="btn btn-primary"
        target="_blank"
        :to="{ name: 'formular', params: { token } }"
        >{{ $t("actions.to_formular") }}</router-link
      >
    </div>
  </b-modal>
</template>

<script>
  import { DateTime } from "luxon";
  import api from "@a/index";
  import VueQrcode from "@chenfengyuan/vue-qrcode";
  import _ from "lodash";

  export default {
    name: "AccessModal",
    components: {
      VueQrcode,
    },
    data() {
      return {
        titel: "",
        token: null,
      };
    },
    methods: {
      async show(formulartypKey, titel, gueltigBis = this.nextDay, ...ref_ids) {
        this.titel = titel;
        let response = await api.privateToken.create(
          formulartypKey,
          gueltigBis.ts,
          _.flatten(ref_ids)
        );
        this.token = response.data.token;

        this.$refs.modal.show();
      },
      onHide() {
        this.token = null;
      },
    },
    computed: {
      nextDay() {
        return DateTime.local().plus({ days: 1 });
      },
    },
  };
</script>

<style>
</style>
